import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import TrialBalanceTable from "../Reusable/TrialBalanceTable";
import Filter from "./Filter";
import { useDownload } from "@careinfo/layout";
import moment from "moment";
import Button from "../Reusable/Button";
import { toHaveFormValues } from "@testing-library/jest-dom/matchers";

const columns: ColumnDef<any, any>[] = [
  {
    accessorKey: "account_name",
    header: "Account Name",
  },
  {
    accessorKey: "debit",
    header: "Debit",
  },
  {
    accessorKey: "credit",
    header: "Credit",
  },
];

export default () => {
  const [searchParams] = useSearchParams();
  const { download } = useDownload();
  const getFilters = useCallback(() => {
    const object = Object.fromEntries(searchParams.entries());
    return object;
  }, [searchParams]);

  const { data: trialBalanceData, isLoading: isDataLoading } = useGetHook({
    queryKey: [`trial-balance-${JSON.stringify(getFilters())}`],
    url: APIS.TRIAL_BALANCE,
    params: {
      ...getFilters(),
    },
  });
const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(toHaveFormValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}valuation-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={tw`space-y-2`}>
      <Filter />
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <TrialBalanceTable
        trialBalanceData={trialBalanceData}
        isLoading={isDataLoading}
      />
    </div>
  );
};
